const TermsIcon = () => {
  return (
    <svg
      width="27"
      height="25"
      viewBox="0 0 27 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4825_6649)">
        <path
          d="M19.5071 21.449C19.0433 21.449 18.6652 21.0734 18.6652 20.6071C18.6652 20.1408 19.0408 19.7652 19.5071 19.7652C19.9734 19.7652 20.349 20.1408 20.349 20.6071C20.349 21.0734 19.9734 21.449 19.5071 21.449ZM20.3465 18.3662C20.3465 18.83 19.9709 19.2081 19.5046 19.2081C19.0382 19.2081 18.6626 18.8325 18.6626 18.3662V16.1252C18.6626 15.6614 19.0382 15.2833 19.5046 15.2833C19.9709 15.2833 20.3465 15.6589 20.3465 16.1252V18.3662ZM4.2818 4.3584H13.8531C14.4127 4.3584 14.879 4.73903 14.879 5.20033C14.879 5.66162 14.4152 6.04226 13.8531 6.04226H4.2818C3.7222 6.04226 3.25586 5.66162 3.25586 5.20033C3.25586 4.73903 3.71968 4.3584 4.2818 4.3584ZM4.09779 7.72107H11.9449C12.4036 7.72107 12.7868 8.1017 12.7868 8.563C12.7868 9.02429 12.4062 9.40493 11.9449 9.40493H4.09779C3.63901 9.40493 3.25586 9.02429 3.25586 8.563C3.25586 8.1017 3.63649 7.72107 4.09779 7.72107ZM7.46046 12.7651H4.09779C3.63901 12.7651 3.25586 12.3844 3.25586 11.9231C3.25586 11.4619 3.63649 11.0812 4.09779 11.0812H7.46046C7.91923 11.0812 8.30239 11.4619 8.30239 11.9231C8.30239 12.3844 7.92176 12.7651 7.46046 12.7651Z"
          fill="#60EC2F"
        />
        <path
          d="M19.507 12.3418C16.2628 12.3418 13.6211 14.981 13.6211 18.2277C13.6211 21.4745 16.2603 24.1137 19.507 24.1137C22.7537 24.1137 25.393 21.4745 25.393 18.2277C25.393 14.981 22.7537 12.3418 19.507 12.3418Z"
          stroke="#60EC2F"
          stroke-width="2.06751"
          stroke-miterlimit="10"
        />
        <path
          d="M17.4413 10.0398V4.70592C17.4413 3.00189 16.0624 1.62305 14.3584 1.62305H4.27037C2.56635 1.62305 1.1875 3.00189 1.1875 4.70592V19.2783C1.1875 20.9824 2.56635 22.3612 4.27037 22.3612H11.8477C10.7941 21.0605 10.1563 19.4019 10.1563 17.597C10.1563 13.5159 13.3955 10.1885 17.4413 10.0423V10.0398Z"
          stroke="#60EC2F"
          stroke-width="2.06751"
          stroke-miterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_4825_6649">
          <rect
            width="25.7141"
            height="24"
            fill="white"
            transform="translate(0.431641 0.868164)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TermsIcon;
